import { render, staticRenderFns } from "./protectionismA.vue?vue&type=template&id=ccd0c344"
import script from "./protectionismA.vue?vue&type=script&lang=js"
export * from "./protectionismA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports